"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _auth = require("@/utils/auth");

var _vuex = require("vuex");

require("video.js/dist/video-js.css");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'Upload',
  components: {},
  data: function data() {
    return {
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      showVideoPath: [],
      imgUrls: [],
      VideoPath: '',
      fileList: []
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['baseApi', 'filesUploadApi'])),
  methods: {
    handleSuccess: function handleSuccess(response, file) {
      this.showVideoPath.push(JSON.stringify(response));
      var videoUrl = file.response.realName == undefined ? JSON.parse(file.response) : file.response;
      this.VideoPath = this.baseApi + '/file/' + videoUrl.type + '/' + videoUrl.realName;
      console.log(this.VideoPath);
      this.$emit('uploadSuccess', this.showVideoPath);
    },
    clearImgs: function clearImgs() {
      this.showVideoPath = [];
      this.VideoPath = '';
      this.fileList = [];
    },
    handleRemove: function handleRemove(file) {
      this.showVideoPath.splice(0, 1);
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      if (["video/mp4", "video/ogg", "video/flv", "video/avi", "video/wmv", "video/rmvb", "video/mov"].indexOf(file.type) == -1) {
        // layer.msg("请上传正确的视频格式");
        this.$message({
          type: "error",
          message: "请上传正确的视频格式"
        });
        return false;
      }

      var isLt1M = file.size / 1024 / 1024 < 100; // 可以限制视频的大小

      if (!isLt1M) {
        this.$message.error('上传视频大小不能超过 50MB!');
      }
    }
  }
};
exports.default = _default;